// src/services/EvaluacionesService.js
import API from "./Config";

const DEVICE_ID_KEY = "pacienteonline_device_id";

const ensureDeviceId = () => {
  if (typeof window === "undefined") {
    return `browser-${Date.now()}`;
  }
  try {
    const existing = localStorage.getItem(DEVICE_ID_KEY);
    if (existing) {
      return existing;
    }
    const generated =
      (window.crypto?.randomUUID && window.crypto.randomUUID()) ||
      `browser-${Date.now()}-${Math.random().toString(16).slice(2)}`;
    localStorage.setItem(DEVICE_ID_KEY, generated);
    return generated;
  } catch (error) {
    console.warn("No se pudo generar el deviceId", error);
    return `browser-${Date.now()}`;
  }
};

const buildPayload = ({ calificacion, comentario }) => {
  const trimmedComment =
    typeof comentario === "string" ? comentario.trim() : undefined;
  return {
    calificacion,
    comentario: trimmedComment || undefined,
    deviceId: ensureDeviceId(),
  };
};

const EvaluacionesService = {
  submitReview: ({ calificacion, comentario }) =>
    API.post("/evaluaciones", buildPayload({ calificacion, comentario })).then(
      (res) => res.data
    ),
  updateReview: ({ calificacion, comentario }) =>
    API.put("/evaluaciones", buildPayload({ calificacion, comentario })).then(
      (res) => res.data
    ),
  fetchMyReview: () =>
    API.get("/evaluaciones/mi-evaluacion").then((res) => res.data),
};

export default EvaluacionesService;
